<template>
  <!-- TODO: These selectors need to be removed from component level and made global -->
  <div v-if="subsidyPrograms">
    <v-row
      v-if="subsidyPrograms.length > 1"
      id="student-index-subsidy-row"
      :class="{
        'bg-primary pt-3 mb-2': !store.state.site.enable_provider_v2,
        'bg-white bb-1 bc-very-light-grey': store.state.site.enable_provider_v2,
      }"
    >
      <v-col
        :class="{
          'd-flex justify-center py-6': !store.state.site.enable_provider_v2,
          'ms-5 pb-5 pt-0': store.state.site.enable_provider_v2,
        }"
      >
        <!-- eslint-disable-next-line prefer-standard-components/no-vuetify-inputs -- TODO migrate to LabeledSelect -->
        <v-select
          v-model="subsidyProgramId"
          :density="store.state.site.enable_provider_v2 ? 'compact' : 'comfortable'"
          :item-title="(subsidyProgram) => subsidyProgram.name"
          :items="subsidyPrograms"
          class="mxw-400"
          data-testid="subsidy-program-select"
          item-value="id"
          variant="solo"
          hide-details
        />
      </v-col>
    </v-row>

    <v-container
      class="mt-3"
      fluid
    >
      <template v-if="subsidyPrograms !== null">
        <v-card
          border
          tile
        >
          <v-card-title
            class="fs-28"
            role="heading"
          >
            {{ $bct(store.state.pages.Students.title || 'Students') }}
          </v-card-title>

          <v-divider />

          <v-toolbar
            v-if="currentSubsidyProgram?.enable_provider_attendance"
            elevation="0"
          >
            <v-tabs>
              <v-tab
                key="Enrollment"
                :to="{ name: 'EnrollmentIndex' }"
                class="w-150 c-black fs-16 fw-500 tt-none ls-normal"
              >
                {{ $bct('All') }}
              </v-tab>

              <v-tab
                key="Attendance"
                :to="{ name: 'AttendanceIndex' }"
                class="w-150 c-black fs-16 fw-500 tt-none ls-normal"
              >
                {{ $bct(terms.attendance) }}
              </v-tab>
            </v-tabs>
          </v-toolbar>

          <v-divider />

          <v-card-text>
            <router-view
              :subsidy-program-id="subsidyProgramId"
              :subsidy-programs="subsidyPrograms"
            />
          </v-card-text>
        </v-card>
      </template>
    </v-container>

    <div id="attendance-log-editor-bar" />
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import useApi from '@/shared/composables/useApi';
import useTerms from '@/shared/composables/useTerms';

const $bct = inject('translator');

const { api: Api } = useApi();
const route = useRoute();
const router = useRouter();
const store = useStore();
const { terms } = useTerms();

const subsidyProgramId = ref(null);
const subsidyPrograms = ref(null);

const currentSubsidyProgram = computed(() => {
  return subsidyPrograms.value?.find((program) => program.id === subsidyProgramId.value);
});

watch(subsidyProgramId, async () => {
  store.commit('setFilters', ['subsidy', { subsidyProgramId: subsidyProgramId.value }]);

  // Handles cases where the user is on AttendanceIndex but the newly selected subsidy program doesn't support attendance
  if (
    route.name === 'AttendanceIndex' &&
    !currentSubsidyProgram.value?.enable_provider_attendance
  ) {
    await router.push({ name: 'EnrollmentIndex' });
  }
});

onMounted(load);

async function load() {
  await loadSubsidyPrograms();
}

async function loadSubsidyPrograms() {
  const { data } = await Api.shared.subsidyProgram.index();
  subsidyPrograms.value = data;
  if (store.state.filters.subsidy?.subsidyProgramId) {
    subsidyProgramId.value = store.state.filters.subsidy.subsidyProgramId;
  } else if (route.query.subsidyProgramId) {
    subsidyProgramId.value = route.query.subsidyProgramId;
  } else {
    subsidyProgramId.value = subsidyPrograms.value[0]?.id;
  }
}
</script>

<style scoped>
.v-tab :deep(.v-btn__content) {
  white-space: normal;
  text-align: center;
}

#student-index-subsidy-row {
  position: sticky;
  top: var(--v-layout-top, 64px);
  z-index: 4;
}
</style>
